
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';


import { styles } from './styles';

import InputFileReader from '../../../fileReader';
class ServiceOwner extends React.Component {
    constructor(props) {
        super(props);
    }
    imageSelect = async(imageURL) => {
      this.props.handleUpdate(null, imageURL)
    }
    render() {  
        const {t, classes, service = {}, handleDelete, handleUpdate, ...props} = this.props;
        return (
            <>  
                <InputFileReader {...props} delete={handleDelete} update={handleUpdate} type="notPreview" disabled={false} onRef = {id => this.InputFileReader = id } defaultImg={service.logo || "/images/no-logo-png-6-transparent.png"}  selectStorageMode={true} imageSelect={this.imageSelect}/>
            </>
        ); 
    }
}
  
ServiceOwner.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapState = state => ({
    
});

const mapDispatch = dispatch => ({
    
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(ServiceOwner)));